import React, { useState, useEffect, useTransition } from "react";
// import '../src/commonCss/loader.css';
import "../src/commonCss/Loader.css";

// import '../commonCss/Loader.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Blog from "./Pages/Blog";
import HomePage from "./Pages/HomePage";
import ContactUs from "./Pages/ContactUs";
import CorporateTravelManagement from "./Pages/CorporateTravelManagement";
import TravelArrangements from "./Pages/TravelArrangements";
import Bliesure from "./Pages/Bliesure";
import Consultation from "./Pages/Consultation";
import Meetings from "./Pages/Meetings";
import GlobalServices from "./Pages/Globalservices";
import OurStory from "./Pages/OurStory";
import MissionAndVission from "./Pages/MissionAndVission";
import Restrictions from "./Pages/Restrictions";
import OurLocation from "./Pages/OurLocation";
import EventWebinar from "./Pages/EventWebinar";
import TechPlatform from "./Pages/TechPlatform";
import Awards from "./Pages/Awards";
import CaseStudies from "./Pages/CaseStudies";
import BlogInner from "./Pages/BlogInner";
import StrategicManagement from "./Pages/StrategicManagement";
import Entertainment from "./Pages/Entertainment";
import SportsTravel from "./Pages/SportsTravel";
import UniversityTravel from "./Pages/UniversityTravel";
import GovernmentTravel from "./Pages/GovernmentTravel";
import CorporateTravelers from "./Pages/CorporateTravelers";
import TermsAndCondition from "./Pages/TermsAndCondition";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import Partners from "./Pages/Partners";
import BlogData from "./Componentsss/BlogInnerPage/BlogData/BlogData";
import CarRentalService from "./Pages/CarRentalServices";
import MIICESolution from "./Pages/MIICESolution";
import Tourism from "./Pages/Tourism";
import BusinessTravel from "./Pages/BusinessTravel";
import { ImageStoreProvider } from "../src/store/ImageStore/ImageStore";
import useLoadTawk from "./hooks/useLoadTawk";
import LoaderWrapper from "./LoaderWrapper";
import WebCheckIn from "./Pages/WebCheckIn";
import BBTCheckInPng from "./images/BBTCheckIn.png";
import AdminPanel from "./Pages/AdminPanel";
import BacklinkManager from "./Pages/BacklinkManager";
import { HelmetProvider } from "react-helmet-async";
import HelmetWrapper from "./HelmetWrapper";

const AppRouter = () => {
  useLoadTawk();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!sessionStorage.getItem("visited")) {
      sessionStorage.setItem("visited", "true");
    }

    const isHomePage = window.location.pathname === "/";
    let fallbackTimer;

    if (isHomePage) {
      const imageSources = [
        {
          src: "https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/Fostering%20connections%20between%20businesses%20and%20Leisure%202.webp",
          srcset: `
          https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/Fostering%20connections%20between%20businesses%20and%20Leisure%202.webp?w=1200 1200w,
          https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/Fostering%20connections%20between%20businesses%20and%20Leisure%202.webp?w=480 480w
        `,
        },
        {
          src: BBTCheckInPng,
        },
        {
          src: "https://blueberrywebsites.azureedge.net/BBT/images/BBTSkyView.webp",
        },
        {
          src: "https://blueberrywebsites.azureedge.net/BBT/images/BBTInterior1.webp",
        },
      ];

      const preloadImage = ({ src, srcset }) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.src = src;
          if (srcset) img.srcset = srcset;
          img.sizes = "100vw";
          img.onload = resolve;
          img.onerror = resolve;
        });
      };

      Promise.all(imageSources.map(preloadImage)).then(() => {
        setLoading(false);
      });

      fallbackTimer = setTimeout(() => {
        setLoading(false);
      }, 1000); // fallback if images hang
    } else {
      const imageSources = [
        {
          src: BBTCheckInPng,
        },
        {
          src: "https://blueberrywebsites.azureedge.net/BBT/images/BBTSkyView.webp",
        },
        {
          src: "https://blueberrywebsites.azureedge.net/BBT/images/BBTInterior1.webp",
        },
      ];

      const preloadImage = ({ src, srcset }) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.src = src;
          if (srcset) img.srcset = srcset;
          img.sizes = "100vw";
          img.onload = resolve;
          img.onerror = resolve;
        });
      };

      Promise.all(imageSources.map(preloadImage)).then(() => {
        setLoading(false);
      });

      fallbackTimer = setTimeout(() => {
        setLoading(false);
      }, 600);
    }

    return () => clearTimeout(fallbackTimer);
  }, []);

  return (
    <>
      {loading ? (
        <div className="loader-container">
          <img src="/BBTloader.gif" alt="Loading..." className="loader-gif" />
        </div>
      ) : (
        <HelmetProvider>
          <Router>
            <HelmetWrapper />
            <Routes>
              <Route
                path="/"
                element={
                  <LoaderWrapper>
                    <HomePage />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/contact"
                element={
                  <LoaderWrapper>
                    <ContactUs />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/blog"
                element={
                  <LoaderWrapper>
                    <Blog />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/corporate-travel"
                element={
                  <LoaderWrapper>
                    <CorporateTravelManagement />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/travel-arrangements"
                element={
                  <LoaderWrapper>
                    <TravelArrangements />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/bliesure"
                element={
                  <LoaderWrapper>
                    <Bliesure />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/consultation"
                element={
                  <LoaderWrapper>
                    <Consultation />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/meeting"
                element={
                  <LoaderWrapper>
                    <Meetings />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/global-solution"
                element={
                  <LoaderWrapper>
                    <GlobalServices />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/our-story"
                element={
                  <LoaderWrapper>
                    <OurStory />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/mission-vision"
                element={
                  <LoaderWrapper>
                    <MissionAndVission />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/restrictions"
                element={
                  <LoaderWrapper>
                    <Restrictions />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/our-location"
                element={
                  <LoaderWrapper>
                    <OurLocation />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/event-webinar"
                element={
                  <LoaderWrapper>
                    <EventWebinar />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/tech-platform"
                element={
                  <LoaderWrapper>
                    <TechPlatform />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/awards"
                element={
                  <LoaderWrapper>
                    <Awards />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/case-studies"
                element={
                  <LoaderWrapper>
                    <CaseStudies />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/blog/:Slug"
                element={
                  <LoaderWrapper>
                    <BlogData />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/business-travel"
                element={
                  <LoaderWrapper>
                    <BusinessTravel />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/strategic"
                element={
                  <LoaderWrapper>
                    <StrategicManagement />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/entertainment"
                element={
                  <LoaderWrapper>
                    <Entertainment />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/sports-travel"
                element={
                  <LoaderWrapper>
                    <SportsTravel />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/university"
                element={
                  <LoaderWrapper>
                    <UniversityTravel />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/government"
                element={
                  <LoaderWrapper>
                    <GovernmentTravel />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/corporate"
                element={
                  <LoaderWrapper>
                    <CorporateTravelers />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/terms-and-conditions"
                element={
                  <LoaderWrapper>
                    <TermsAndCondition />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/privacy-policy"
                element={
                  <LoaderWrapper>
                    <PrivacyPolicy />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/partners"
                element={
                  <LoaderWrapper>
                    <Partners />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/car-rental-services"
                element={
                  <LoaderWrapper>
                    <CarRentalService />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/MICESolutions"
                element={
                  <LoaderWrapper>
                    <MIICESolution />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/tourism"
                element={
                  <LoaderWrapper>
                    <Tourism />
                  </LoaderWrapper>
                }
              />
              <Route
                path="/web-flight-check-in"
                element={
                  <LoaderWrapper>
                    <WebCheckIn />
                  </LoaderWrapper>
                }
              />
              {/* <Route
                path="/admin-panel"
                element={
                  <LoaderWrapper>
                    <AdminPanel />
                  </LoaderWrapper>
                }
              /> */}
              {/* <Route
                path="/backlinks"
                element={
                  <LoaderWrapper>
                    <BacklinkManager />
                  </LoaderWrapper>
                }
              /> */}
            </Routes>
          </Router>
        </HelmetProvider>
      )}
    </>
  );
};

export default AppRouter;
